import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('voidwolves_token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            verifyToken();
        } else {
            setLoading(false);
        }
    }, [token]);

    const verifyToken = async () => {
        try {
            const response = await axios.get(`${API}/auth/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAdmin(response.data);
        } catch (error) {
            console.error('Token verification failed:', error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (username, password) => {
        const response = await axios.post(`${API}/auth/login`, { username, password });
        const { access_token } = response.data;
        localStorage.setItem('voidwolves_token', access_token);
        setToken(access_token);
        // Immediately verify and set admin data
        const meResponse = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${access_token}` }
        });
        setAdmin(meResponse.data);
        return response.data;
    };

    const loginWithToken = async (access_token) => {
        localStorage.setItem('voidwolves_token', access_token);
        const meResponse = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${access_token}` }
        });
        setToken(access_token);
        setAdmin(meResponse.data);
    };

    const register = async (username, password) => {
        const response = await axios.post(`${API}/auth/register`, { username, password });
        const { access_token } = response.data;
        localStorage.setItem('voidwolves_token', access_token);
        setToken(access_token);
        // Immediately verify and set admin data
        const meResponse = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${access_token}` }
        });
        setAdmin(meResponse.data);
        return response.data;
    };

    const logout = () => {
        localStorage.removeItem('voidwolves_token');
        setToken(null);
        setAdmin(null);
    };

    const getAuthHeaders = () => ({
        headers: { Authorization: `Bearer ${token}` }
    });

    return (
        <AuthContext.Provider value={{ admin, token, loading, login, loginWithToken, register, logout, getAuthHeaders }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
